const sortComponentsByOrder = (components) => {
    return Object.entries(components)
        .map(([id, componentValues]) => (Object.assign(Object.assign({}, componentValues), { id })))
        .sort(({ order: orderA }, { order: orderB }) => (orderA && orderB ? orderA - orderB : 1));
};
export default sortComponentsByOrder;
//# sourceMappingURL=sortComponentsByOrder.js.map